/*
 * Tabs content component
 *
 * @param {String} tab Active tab
 *
 * @return {Element}
 */
<template>
  <div class="tab-content setting-tab-content">
    <div id="user-info" class="tab-pane" :class="activeTab('user-info')">
      <user-info :currentTab="tab" @checkData="checkData"></user-info>
    </div>
    <div id="login-info" class="tab-pane" :class="activeTab('login-info')">
      <login-info :currentTab="tab"></login-info>
    </div>
    <div id="plan-info" class="tab-pane" :class="activeTab('plan-info')">
      <plan-info :currentTab="tab"></plan-info>
    </div>
    <div id="service-info" class="tab-pane" :class="activeTab('service-info')">
      <service-info :currentTab="tab"></service-info>
    </div>
    <div id="payment-info" class="tab-pane" :class="activeTab('payment-info')">
      <pay-info :currentTab="tab"></pay-info>
    </div>
    <div id="payment-cycle" class="tab-pane" :class="activeTab('payment-cycle')">
      <pay-cycle :currentTab="tab"></pay-cycle>
    </div>
    <div id="agent-notice" class="tab-pane" :class="activeTab('agent-notice')">
      <agent-notice :currentTab="tab"></agent-notice>
    </div>
    <div id="others" class="tab-pane" :class="activeTab('others')">
      <others :currentTab="tab"></others>
    </div>
  </div>
</template>
<script>
import UserInfo from './UserInfo'
import LoginInfo from './LoginInfo'
import ServiceInfo from './ServiceInfo'
import PayInfo from './PayInfo'
import PayCycle from './PayCycle'
import AgentNotice from './AgentNotice'
import Others from './Others'
import PlanInfo from './PlanInfo'

export default {
  components: {
    UserInfo,
    LoginInfo,
    ServiceInfo,
    PayInfo,
    PayCycle,
    AgentNotice,
    Others,
    PlanInfo
  },
  props: {
    tab: {
      type: String,
      default: 'user-info'
    }
  },
  methods: {
    /*
     * Check data to disable/enable tab
     *
     * @param {Boolean} hasData User information exist or not
     *
     * @return void
     */
    checkData (hasData) {
      this.$emit('checkData', hasData)
    },
    /*
     * Check tab is active or not
     *
     * @param {String} tabName Tab's name
     *
     * @return {String}
     */
    activeTab (tabName) {
      return this.tab === tabName ? 'active' : ''
    }
  },
  mounted () {
    if (this.tab === 'user-info') {
      $('.setting-tab-content').css('max-width', '950px')
      $('.setting-nav-tabs').css('max-width', '950px')
    } else if (this.tab === 'plan-info') {
      $('.setting-tab-content').css('max-width', '1200px')
      $('.setting-nav-tabs').css('max-width', '1200px')
    } else {
      $('.setting-tab-content').css('max-width', '900px')
      $('.setting-nav-tabs').css('max-width', '900px')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/setting/TabContent.vue